import * as React from "react";
import { useTranslation } from "react-i18next";
import { IReceptionPlacePoint } from "../interfaces/IReceptionPlacePoint";
import { wrapperStyles } from "../styles/style";

export interface ReceptionPlacesPopupHtmlProps {
    receptionPlacePoint: IReceptionPlacePoint;
}

export const ReceptionPlacesPopupHtml: React.FC<ReceptionPlacesPopupHtmlProps> = ({ receptionPlacePoint }) => {
    const { t } = useTranslation("admin");
    return (
        <div style={wrapperStyles.popupStyles}>
            <b>{receptionPlacePoint.companyName}</b>< br />
            {t("nav.nip")}: {receptionPlacePoint.taxNumber} <br />
            {t("nav.bdo")}: {receptionPlacePoint.bdoNumber} <br />
            {receptionPlacePoint.street} <br />
            {receptionPlacePoint.city} {receptionPlacePoint.postalCode}< br />
            {t("storeMap.popup.distances")}: < br />
            {receptionPlacePoint.distances.map(distance =>
                <>
                    {distance.name}: {distance.distance} km < br />
                </>
            )
            }
        </div>
    )
}